/**
 * Product limits enforced server-side. The free tier is capped at
 * FREE_WEEKLY_IMPORTS imports per a rolling IMPORT_QUOTA_WINDOW_DAYS-day window;
 * `plus` is uncapped. These live in the contract so the API enforces and the
 * client explains the same numbers.
 */
export const LIMITS = {
    FREE_WEEKLY_IMPORTS: 5,
    IMPORT_QUOTA_WINDOW_DAYS: 7,
};
//# sourceMappingURL=limits.js.map